export default __webpack_public_path__ + "img/fa7ce996e0c9164314a0411c83dabab1.svg";